/**
 * FlyFreely API
 *
 * Contact: support@flyfreely.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EquipmentActions } from './equipmentActions';
import { EquipmentTypeDto } from './equipmentTypeDto';
import { InitialComponentDto } from './initialComponentDto';
import { LockedEquipmentFields } from './lockedEquipmentFields';
import { SimpleOrganisationDto } from './simpleOrganisationDto';

export interface EquipmentDto {
    /**
     * The unique ID for this instance
     */
    id: number;
    /**
     * The organisation that owns this entity
     */
    organisationId: number;
    /**
     * The model of the equipment
     */
    equipmentType: EquipmentTypeDto;
    /**
     * The name of equipment
     */
    name: string;
    /**
     * The date the equipment was originally purchased
     */
    purchaseDate?: string;
    /**
     * The date the equipment was no longer owned by the organisation
     */
    disposalDate?: string;
    /**
     * General notes made about an RPA by the owner
     */
    notes?: string;
    /**
     * The serial number of equipment
     */
    manufacturerSerialNumber: string;
    /**
     * The firmware that is currently on the equipment
     */
    currentFirmwareVersion?: string;
    /**
     * The ID of the NFC tag that is on the equipment
     */
    nfcId?: string;
    /**
     * The timestamp when the entity was first stored
     */
    creationTime?: string;
    /**
     * The timestamp when the entity was last stored
     */
    modificationTime?: string;
    /**
     * Flag to indicate whether this Equipment is a dummy
     */
    isDummy: boolean;
    /**
     * The fields of equipment that are locked for editing
     */
    lockedFields: LockedEquipmentFields;
    /**
     * The status of the equipment
     */
    status: EquipmentDto.Status;
    /**
     * The organisation that owns this entity
     */
    organisation: SimpleOrganisationDto;
    /**
     * The organisation that currently has possession of the RPA
     */
    custodian?: SimpleOrganisationDto;
    /**
     * ${swagger.Equipment.maintenanceOrganisation}
     */
    maintenanceOrganisation: SimpleOrganisationDto;
    /**
     * The actions that can be performed by the current user
     */
    availableActions: EquipmentActions;
    initialComponentList?: Array<InitialComponentDto>;
}
export namespace EquipmentDto {
    export type Status =
        | 'SERVICEABLE'
        | 'UNSERVICEABLE'
        | 'UNDER_MAINTENANCE'
        | 'RETIRED'
        | 'DISPOSED'
        | 'DELETED';
    export const Status = {
        SERVICEABLE: 'SERVICEABLE' as Status,
        UNSERVICEABLE: 'UNSERVICEABLE' as Status,
        UNDER_MAINTENANCE: 'UNDER_MAINTENANCE' as Status,
        RETIRED: 'RETIRED' as Status,
        DISPOSED: 'DISPOSED' as Status,
        DELETED: 'DELETED' as Status
    };
}
